module.exports = __webpack_public_path__ + "static/media/GD.32942a8a.svg";